/**
 * The smallest width a column can be resized to
 */
export const minColumnWidth = 200;
